import {
  GET_SETTINGS_SMTP_START,
  GET_SETTINGS_SMTP_FAIL,
  GET_SETTINGS_SMTP_SUCCESS,
  SAVE_SETTINGS_SMTP_START,
  SAVE_SETTINGS_SMTP_SUCCESS,
  SAVE_SETTINGS_SMTP_FAIL,
  SET_SETTINGS_SMTP_FIELD
} from 'store/Settings/smtpActions';

import {
  SAVE_SETTINGS_CHANGE_PASSWORD_START,
  SAVE_SETTINGS_CHANGE_PASSWORD_SUCCESS,
  SAVE_SETTINGS_CHANGE_PASSWORD_FAIL
} from 'store/Settings/changePasswordActions';

import {
  GET_SETTINGS_TWO_FACTOR_START,
  GET_SETTINGS_TWO_FACTOR_SUCCESS,
  GET_SETTINGS_TWO_FACTOR_FAIL,

  SET_SETTINGS_TWO_FACTOR_REQUEST_START,
  SET_SETTINGS_TWO_FACTOR_REQUEST_SUCCESS,
  SET_SETTINGS_TWO_FACTOR_REQUEST_FAIL,

  SET_SETTINGS_TWO_FACTOR_CONFIRM_START,
  SET_SETTINGS_TWO_FACTOR_CONFIRM_SUCCESS,
  SET_SETTINGS_TWO_FACTOR_CONFIRM_FAIL,

  SET_SETTINGS_TWO_FACTOR_DISABLE_START,
  SET_SETTINGS_TWO_FACTOR_DISABLE_SUCCESS,
  SET_SETTINGS_TWO_FACTOR_DISABLE_FAIL,

  CLEAR_SETTINGS_TWO_FACTOR_MESSAGE,

  SET_SETTINGS_TWO_FACTOR_CHANGE_STATUS_SUCCESS
} from 'store/Settings/twoFactorActions';

import get from 'lodash/get';
import {
  LOAD_SETTINGS_LOGIN_SETTINGS_SUCCESS,
  SAVE_SETTINGS_LOGIN_SETTINGS_FAIL,
  SAVE_SETTINGS_LOGIN_SETTINGS_START,
  SAVE_SETTINGS_LOGIN_SETTINGS_CLEAR,
  SAVE_SETTINGS_LOGIN_SETTINGS_SUCCESS,
  SET_SETTINGS_CHANGE_LOGIN_SETTINGS_FIELD
} from './loginSettingsActions';
import {
  GET_SETTINGS_TEMPLATES_FAIL, GET_SETTINGS_TEMPLATES_START, GET_SETTINGS_TEMPLATES_SUCCESS, SET_SETTINGS_SHOW_MODAL,

  SEND_VULN_TO_TOOL,
  GET_ACTIVE_CONFIG_REQUEST,
  GET_ACTIVE_CONFIG_SUCCESS,
  GET_ACTIVE_CONFIG_FAILURE,
  GET_USER_DATA_SUCCESS,
  GET_USER_DATA_FAIL,
  SET_USER_EMAIL,
  UPDATE_ACTIVE_CONFIG_FAILURE,
  UPDATE_ACTIVE_CONFIG_SUCCESS_BY_TOOL,
  SET_STATUS,
  SET_VERIFY_EMAIL_DATA,
  SET_EMAIL_TO_VERIFY
} from './settingsActions';
import {
  ACCESS_SETTINGS_TICKETING_TOOLS_JIRA_FAIL,
  ACCESS_SETTINGS_TICKETING_TOOLS_JIRA_START,
  ACCESS_SETTINGS_TICKETING_TOOLS_JIRA_SUCCESS,
  AUTHORIZE_SETTINGS_TICKETING_TOOLS_JIRA_FAIL,
  AUTHORIZE_SETTINGS_TICKETING_TOOLS_JIRA_START,
  AUTHORIZE_SETTINGS_TICKETING_TOOLS_JIRA_SUCCESS,
  GET_SETTINGS_TICKETING_TOOLS_JIRA_FAIL,
  GET_SETTINGS_TICKETING_TOOLS_JIRA_START,
  GET_SETTINGS_TICKETING_TOOLS_JIRA_SUCCESS,
  SAVE_SETTINGS_TICKETING_TOOLS_JIRA_FAIL,
  SAVE_SETTINGS_TICKETING_TOOLS_JIRA_START,
  SAVE_SETTINGS_TICKETING_TOOLS_JIRA_SUCCESS,
  SET_SETTINGS_TICKETING_TOOLS_JIRA_FIELD,
  GET_PROJECTS_TICKETING_TOOLS_JIRA_START,
  GET_PROJECTS_TICKETING_TOOLS_JIRA_SUCCESS,
  GET_PROJECTS_TICKETING_TOOLS_JIRA_FAIL,
  ADD_TO_JIRA_PAYLOAD,
  SET_JIRA_PAYLOAD,
  SET_JIRA_TEMPLATE,
  RESET_JIRA_PAYLOAD,
  ADD_PROJECT_JIRA_PAYLOAD,
  DELETE_PROJECT_JIRA_PAYLOAD,
  SET_PROJECT_CONFIG_JIRA_PAYLOAD,
  SEND_TEMPLATES_TICKETING_TOOLS_JIRA_SUCCESS,
  SEND_TEMPLATES_TICKETING_TOOLS_JIRA_START,
  SEND_TEMPLATES_TICKETING_TOOLS_JIRA_FAIL,
  GET_PUBLIC_KEY_TICKETING_TOOLS_JIRA_SUCCESS,
  GET_PUBLIC_KEY_TICKETING_TOOLS_JIRA_START,
  GET_PUBLIC_KEY_TICKETING_TOOLS_JIRA_FAIL,
  GET_PROJECT_TICKETING_TOOLS_JIRA_START,
  GET_PROJECT_TICKETING_TOOLS_JIRA_SUCCESS,
  GET_PROJECT_TICKETING_TOOLS_JIRA_FAIL,
  SET_IS_TEMPLATE,
  SET_PROJECT_BY_DEFAULT_JIRA_FAIL,
  SET_PROJECT_BY_DEFAULT_JIRA_SUCCESS,
  SET_PROJECT_BY_DEFAULT_JIRA_START,
  GET_JIRA_AVAILABLE_PROJECTS,
  GET_JIRA_CONFIGURED_PROJECTS,
  UPDATE_JIRA_CONFIGURED_PROJECT,
  SET_PROJECT_TO_SUBMIT_ISSUE,
  FETCHING_AUTHENTICATE_START,
  GET_AVAILABLE_PROJECTS_JIRA_START,
  GET_PROJECT_DATA_START
} from './jiraActions';
import {
  ADD_USER_TICKETING_TOOLS_JIRA,
  AUTHENTICATE_SETTINGS_TICKETING_TOOLS_SERVICE_NOW_FAIL,
  AUTHENTICATE_SETTINGS_TICKETING_TOOLS_SERVICE_NOW_START,
  AUTHENTICATE_SETTINGS_TICKETING_TOOLS_SERVICE_NOW_SUCCESS,
  DEAUTHENTICATE_SETTINGS_TICKETING_TOOLS_SERVICE_NOW_FAIL,
  DEAUTHENTICATE_SETTINGS_TICKETING_TOOLS_SERVICE_NOW_START,
  DEAUTHENTICATE_SETTINGS_TICKETING_TOOLS_SERVICE_NOW_SUCCESS,
  DELETE_USER_TICKETING_TOOLS_JIRA,
  GET_SETTINGS_TICKETING_TOOLS_SERVICE_NOW_FAIL, GET_SETTINGS_TICKETING_TOOLS_SERVICE_NOW_START, GET_SETTINGS_TICKETING_TOOLS_SERVICE_NOW_SUCCESS, SAVE_SETTINGS_TICKETING_TOOLS_SERVICE_NOW_FAIL, SAVE_SETTINGS_TICKETING_TOOLS_SERVICE_NOW_START, SAVE_SETTINGS_TICKETING_TOOLS_SERVICE_NOW_SUCCESS, SET_SETTINGS_TICKETING_TOOLS_SERVICE_NOW_FIELD,
  TABLE_TO_LABEL_MAP
} from './serviceNowActions';
import {
  GET_SETTINGS_TICKETING_TOOLS_GITLAB_FAIL, GET_SETTINGS_TICKETING_TOOLS_GITLAB_START, GET_SETTINGS_TICKETING_TOOLS_GITLAB_SUCCESS, SAVE_SETTINGS_TICKETING_TOOLS_GITLAB_FAIL, SAVE_SETTINGS_TICKETING_TOOLS_GITLAB_START, SAVE_SETTINGS_TICKETING_TOOLS_GITLAB_SUCCESS, SET_SETTINGS_TICKETING_TOOLS_GITLAB_FIELD
} from './gitLabActions';
import {
  GET_SETTINGS_TICKETING_TOOLS_SOLARWINDS_FAIL, GET_SETTINGS_TICKETING_TOOLS_SOLARWINDS_START, GET_SETTINGS_TICKETING_TOOLS_SOLARWINDS_SUCCESS, SAVE_SETTINGS_TICKETING_TOOLS_SOLARWINDS_FAIL, SAVE_SETTINGS_TICKETING_TOOLS_SOLARWINDS_START, SAVE_SETTINGS_TICKETING_TOOLS_SOLARWINDS_SUCCESS, SET_SETTINGS_TICKETING_TOOLS_SOLARWINDS_FIELD
} from './solarWindsActions';
import * as types from './types';
import { ADD_USER_TOKEN_TO_TABLE, RESET_LAST_ADDED_TOKEN, SETTINGS_GET_USER_TOKENS_REQUEST, SETTINGS_GET_USER_TOKENS_SUCCESS, SETTINGS_USER_TOKENS_CREATE_SUCCESS, SETTINGS_USER_TOKENS_FAIL, SETTINGS_USER_TOKENS_GET_SCOPES, SETTINGS_USER_TOKENS_RESET_ERROR, SETTINGS_USER_TOKENS_SET_SELECTED_TAB, SETTINGS_USER_TOKENS_SHOW_ACTION_MODAL, SETTINGS_USER_TOKENS_SHOW_ADD_TOKEN_MODAL } from './accessTokens/types';
import { SET_INSTANCE_SETTINGS_START, SET_INSTANCE_SETTINGS_SUCCESS } from './instanceSettingsActions';
import {
  GET_SETTINGS_TICKETING_TOOLS_SERVICE_DESK_FAIL,
  GET_SETTINGS_TICKETING_TOOLS_SERVICE_DESK_START,
  GET_SETTINGS_TICKETING_TOOLS_SERVICE_DESK_SUCCESS,
  SETTINGS_SERVICE_DESK_ACTIVATE_TEMPLATE_FAILURE,
  SETTINGS_SERVICE_DESK_ACTIVATE_TEMPLATE_SUCCESS,
  SETTINGS_SERVICE_DESK_AUTH_FAILURE,
  SETTINGS_SERVICE_DESK_AUTH_SUCCESS,
  SETTINGS_SERVICE_DESK_BASIC_SETUP_FAILURE,
  SETTINGS_SERVICE_DESK_BASIC_SETUP_SUCCESS,
  SETTINGS_SERVICE_DESK_DEAUTHENTICATED,
  SETTINGS_SERVICE_DESK_DELETE_TEMPLATE_FAILURE,
  SETTINGS_SERVICE_DESK_DELETE_TEMPLATE_SUCCESS,
  SETTINGS_SERVICE_DESK_FAILURE,
  SETTINGS_SERVICE_DESK_GET_DROPDOWN_DATA_SUCCESS,
  SETTINGS_SERVICE_DESK_GET_GROUPED_DROPDOWN_DATA_REQUEST,
  SETTINGS_SERVICE_DESK_GET_GROUPED_DROPDOWN_DATA_SUCCESS,
  SETTINGS_SERVICE_DESK_GET_REQUESTERS_SUCCESS,
  SETTINGS_SERVICE_DESK_GET_SEARCH_DATA_SUCCESS,
  SETTINGS_SERVICE_DESK_REMOVE_VALUE_SEARCH,
  SETTINGS_SERVICE_DESK_REQUEST,
  SETTINGS_SERVICE_DESK_RESET,
  SETTINGS_SERVICE_DESK_RESET_TEMPLATE,
  SETTINGS_SERVICE_DESK_SAVE_TEMPLATES_FAILURE,
  SETTINGS_SERVICE_DESK_SAVE_TEMPLATES_SUCCESS,
  SETTINGS_SERVICE_DESK_SET_FIELD,
  SETTINGS_SERVICE_DESK_SET_INCOMING_STATUS,
  SETTINGS_SERVICE_DESK_SET_OUTGOING_STATUS,
  SETTINGS_SERVICE_DESK_SET_REQUESTER,
  SETTINGS_SERVICE_DESK_SET_SEVERITIES_TYPE,
  SETTINGS_SERVICE_DESK_SET_VALUE_SEARCH,
  SETTINGS_SERVICE_DESK_SUCCESS,
  SETTINGS_SERVICE_DESK_TEMPLATE_DATA_REQUEST,
  SETTINGS_SERVICE_DESK_TEMPLATE_DATA_SUCCESS,
  SETTINGS_SERVICE_DESK_TEMPLATES_FAILURE,
  SETTINGS_SERVICE_DESK_TEMPLATES_REQUEST,
  SETTINGS_SERVICE_DESK_TEMPLATES_SUCCESS,
  SETTINGS_SERVICE_DESK_UPDATE_TEMPLATE_SELECTED,
  TEMPLATE_SELECTED_SD
} from './serviceDesk/types';

// Report settings tab is Enterprise Edition-only (src/ee/store/Settings/reportActions.js);
// the reducer keeps its own copy of these action-type strings so it never imports from ee/.
const SET_SETTINGS_REPORT_FIELD = 'SET_SETTINGS_REPORT_FIELD';
const SAVE_SETTINGS_REPORT_SUCCESS = 'SAVE_SETTINGS_REPORT_SUCCESS';
const LOAD_SETTINGS_REPORT_SUCCESS = 'LOAD_SETTINGS_REPORT_SUCCESS';

const initialState = {
  smtp: {
    hostname: '',
    sender: '',
    port: '',
    username: '',
    password: '',
    error: false,
    message: '',
    isFetching: false
  },
  saml: {
    isFetching: false,
    enabled: false,
    userRole: '',
    displayName: '',
    attributeIdentifier: '',
    spCertificate: '',
    idpCertificate: '',
    identityId: '',
    ssoUrl: '',
    spPrivateKey: ''
  },
  changePassword: {
    isFetching: false,
    error: false,
    message: ''
  },
  twoFactor: {
    status: 'disabled', // disabled, requested, confirmed
    checked: false,
    toggledByUser: false
  },
  loginSettings: {
    checked: false
  },
  report: {
    useMarkdown: false,
    borderWidth: 0
  },
  ticketingTools: {
    isFetching: false,
    templates: [],
    activeConfig: { ...types.DEFAULT_ACTIVE_CONFIG, isLoading: false, error: null },

    solarWinds: {
      url: '',
      apiKey: '',
      template: '',
      error: false,
      message: ''
    },
    gitLab: {
      url: '',
      accessToken: '',
      project: '',
      sslVerify: false,
      selfSignedCertificate: false,
      template: '',
      error: false,
      message: ''
    },
    serviceNow: {
      authenticated: false,
      category: '',
      subcategory: '',
      template: '',
      url: '',
      isFetching: false,
      error: false,
      message: ''
    },
    jira: {
      authenticated: false,
      authorized: false,
      customFields: {},
      issueType: '',
      template: {},
      templates: [],
      users: [],
      isTemplate: false,
      consumerKey: '',
      projectKey: '',
      url: '',
      isFetching: false,
      error: false,
      success: false,
      message: '',
      publicKey: '',
      ticketConfig: {},
      defaultProject: '',
      availableProjects: [],
      configuredProjects: [],
      projectToSubmitIssue: null,
      fetchingAuthenticate: false,
      fetchingProjects: false,
      fetchingProjectData: false,
      payload: {
        merge_vulns: false,
        issue_name: '',
        projects_selected: [],
        projects_changed: {}
      }
    },
    serviceDesk: {
      isFetching: false,
      error: false,
      errorMessage: '',
      requester: [],
      severity_outgoing: {},
      status_outgoing: {},
      status_incoming: {},
      isFetchingTemplates: false,
      templatesAvailable: [],
      template_list: [],
      active_template: '',
      basic_setup_configured: false,
      successful_login: false,
      templateSelected: {},
      isFetchingTemplateData: false
    }
  },
  ldap: {
    enabled: false,
    server: '',
    port: null,
    domain: '',
    domain_dn: '',
    bind_format: '',
    bind_dn: '',
    user_attribute: '',
    use_local_roles: true,
    default_local_role: '',
    admin_group: '',
    pentester_group: '',
    client_group: '',
    asset_owner_group: '',
    use_ldaps: false,
    use_start_tls: false,
    disconnect_timeout: null,
    paginated_fetch: false,
    user_class: '',
    group_class: '',
    error: false,
    message: '',
    isFetching: false
  },
  instanceSettings: {
    allowMultipleSessions: false
  },
  verifyEmailData: {
    message: '',
    emailToVerify: ''
  }
};

function settings (state = initialState, action) {
  switch (action.type) {
    // SMTP section
    case GET_SETTINGS_SMTP_START: {
      return {
        ...state,
        smtp: {
          ...initialState.smtp,
          isFetching: true
        }
      };
    }

    case GET_SETTINGS_SMTP_FAIL: {
      return {
        ...state,
        smtp: {
          ...state.smtp,
          isFetching: false,
          error: true,
          message: action.data
        }
      };
    }

    case GET_SETTINGS_SMTP_SUCCESS: {
      return {
        ...state,
        smtp: {
          isFetching: false,
          hostname: action.response.host,
          sender: action.response.sender,
          port: action.response.port,
          password: action.response.password,
          username: action.response.username,
          enabled: action.response.enabled,
          ssl: action.response.ssl
        }
      };
    }

    case SAVE_SETTINGS_SMTP_START: {
      return {
        ...state,
        smtp: {
          ...state.smtp,
          isFetching: true
        }
      };
    }

    case SAVE_SETTINGS_SMTP_SUCCESS: {
      return {
        ...state,
        smtp: {
          ...state.smtp,
          isFetching: false,
          error: false,
          message: 'Your data was saved successfully.'
        }
      };
    }

    case SAVE_SETTINGS_SMTP_FAIL: {
      return {
        ...state,
        smtp: {
          ...state.smtp,
          isFetching: false,
          error: false,
          message: action.message
        }
      };
    }

    case SET_SETTINGS_SMTP_FIELD: {
      return {
        ...state,
        smtp: {
          ...state.smtp,
          [action.field]: action.value
        }
      };
    }

    //
    // REPORT section
    //
    case SET_SETTINGS_REPORT_FIELD: {
      return {
        ...state,
        report: {
          ...state.report,
          [action.field]: action.value
        }
      };
    }

    //
    // CHANGE PASSWORD section
    //
    case SAVE_SETTINGS_CHANGE_PASSWORD_START: {
      return {
        ...state,
        changePassword: {
          ...state.changePassword,
          isFetching: true
        }
      };
    }

    case SAVE_SETTINGS_CHANGE_PASSWORD_SUCCESS: {
      return {
        ...state,
        changePassword: {
          ...initialState.changePassword,
          error: false,
          message: 'Your password was saved successfully.',
          isFetching: false
        }
      };
    }

    case SAVE_SETTINGS_CHANGE_PASSWORD_FAIL: {
      return {
        ...state,
        changePassword: {
          ...state.changePassword,
          isFetching: false,
          error: true,
          message: action.message
        }
      };
    }

    //
    // TWO FACTOR section
    //
    case GET_SETTINGS_TEMPLATES_START: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          templates: state.ticketingTools.templates,
          isFetching: true
        }
      };
    }

    case GET_SETTINGS_TEMPLATES_SUCCESS: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          templates: action.templates,
          isFetching: false
        }
      };
    }

    case GET_SETTINGS_TEMPLATES_FAIL: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          templates: state.ticketingTools.templates,
          isFetching: false
        }
      };
    }

    case GET_SETTINGS_TWO_FACTOR_START: {
      return {
        ...state,
        twoFactor: {
          ...state.twoFactor,
          isFetching: true
        }
      };
    }

    case GET_SETTINGS_TWO_FACTOR_SUCCESS: {
      return {
        ...state,
        twoFactor: {
          ...state.twoFactor,
          status: action.status,
          checked: action.status === 'confirmed',
          toggledByUser: false,
          isFetching: false,
          error: false,
          message: ''
        }
      };
    }

    case GET_SETTINGS_TWO_FACTOR_FAIL: {
      return {
        ...state,
        twoFactor: {
          ...state.twoFactor,
          isFetching: false,
          error: true,
          message: action.message
        }
      };
    }

    case SET_SETTINGS_TWO_FACTOR_REQUEST_START: {
      return {
        ...state,
        twoFactor: {
          ...state.twoFactor,
          isFetching: true
        }
      };
    }

    case SET_SETTINGS_TWO_FACTOR_REQUEST_SUCCESS: {
      return {
        ...state,
        twoFactor: {
          ...state.twoFactor,
          status: action.status,
          isFetching: false,
          error: false,
          message: 'Two factor authentication request has been started successfully'
        }
      };
    }

    case SET_SETTINGS_TWO_FACTOR_REQUEST_FAIL: {
      return {
        ...state,
        twoFactor: {
          ...state.twoFactor,
          isFetching: false,
          error: true,
          message: action.message
        }
      };
    }

    case SET_SETTINGS_TWO_FACTOR_CONFIRM_START: {
      return {
        ...state,
        twoFactor: {
          ...state.twoFactor,
          error: false,
          message: '',
          confirmed: false,
          isFetching: true
        }
      };
    }

    case SET_SETTINGS_TWO_FACTOR_CONFIRM_SUCCESS: {
      return {
        ...state,
        twoFactor: {
          ...state.twoFactor,
          status: 'confirmed',
          error: false,
          message: 'Two factor authentication has been activated successfully!',
          isFetching: false
        }
      };
    }

    case SET_SETTINGS_TWO_FACTOR_CONFIRM_FAIL: {
      return {
        ...state,
        twoFactor: {
          ...state.twoFactor,
          confirmed: false,
          isFetching: false,
          error: true,
          message: action.message
        }
      };
    }

    case SET_SETTINGS_TWO_FACTOR_DISABLE_START: {
      return {
        ...state,
        twoFactor: {
          ...state.twoFactor,
          isFetching: true,
          error: false,
          message: ''
        }
      };
    }

    case SET_SETTINGS_TWO_FACTOR_DISABLE_SUCCESS: {
      return {
        ...state,
        twoFactor: {
          ...state.twoFactor,
          status: 'disabled',
          isFetching: false,
          error: false,
          message: 'Two factor authentication has been disabled successfully!'
        }
      };
    }

    case SET_SETTINGS_TWO_FACTOR_DISABLE_FAIL: {
      return {
        ...state,
        twoFactor: {
          ...state.twoFactor,
          isFetching: false,
          error: true,
          message: action.message
        }
      };
    }

    case SET_SETTINGS_TWO_FACTOR_CHANGE_STATUS_SUCCESS: {
      return {
        ...state,
        twoFactor: {
          ...state.twoFactor,
          checked: action.checked,
          toggledByUser: true,
          error: false,
          message: ''
        }
      };
    }

    case CLEAR_SETTINGS_TWO_FACTOR_MESSAGE: {
      return {
        ...state,
        twoFactor: {
          ...state.twoFactor,
          error: false,
          message: ''
        }
      };
    }

    //
    // LOGIN SETTINGS section
    //
    case SET_SETTINGS_CHANGE_LOGIN_SETTINGS_FIELD: {
      return {
        ...state,
        loginSettings: {
          ...state.loginSettings,
          [action.field]: action.value
        }
      };
    }

    case SAVE_SETTINGS_LOGIN_SETTINGS_START: {
      return {
        ...state,
        loginSettings: {
          ...state.loginSettings,
          isFetching: true
        }
      };
    }

    case SAVE_SETTINGS_LOGIN_SETTINGS_CLEAR: {
      return {
        ...state,
        changePassword: {
          ...initialState.changePassword
        }
      };
    }

    case SAVE_SETTINGS_LOGIN_SETTINGS_SUCCESS: {
      return {
        ...state,
        loginSettings: {
          ...state.loginSettings,
          logMeLastWorkspaceUsed: action.logMeLastWorkspaceUsed,
          isFetching: false,
          error: false,
          message: action.message
        },
        userData: {
          ...state.userData,
          email: action.email
        }
      };
    }

    case SAVE_SETTINGS_LOGIN_SETTINGS_FAIL: {
      return {
        ...state,
        loginSettings: {
          ...state.loginSettings,
          isFetching: false,
          error: true,
          message: action.message
        }
      };
    }

    case LOAD_SETTINGS_LOGIN_SETTINGS_SUCCESS: {
      return {
        ...state,
        loginSettings: {
          ...state.loginSettings,
          logMeLastWorkspaceUsed: action.autoSelectWs,
          isFetching: false
        }
      };
    }

    // COMMON SETTINGS section
    case SET_SETTINGS_SHOW_MODAL: {
      return {
        ...state,
        showModal: action.showModal
      };
    }

    // REPORT section
    case SAVE_SETTINGS_REPORT_SUCCESS: {
      return {
        ...state,
        report: {
          ...state.report,
          useMarkdown: action.useMarkdown,
          borderWidth: action.borderWidth
        }
      };
    }

    case LOAD_SETTINGS_REPORT_SUCCESS: {
      return {
        ...state,
        report: {
          ...state.report,
          useMarkdown: action.useMarkdown,
          borderWidth: action.borderWidth
        }
      };
    }

    // TICKETING TOOLS
    // solarwinds
    case GET_SETTINGS_TICKETING_TOOLS_SOLARWINDS_START: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          solarWinds: {
            ...initialState.ticketingTools.solarWinds,
            isFetching: true
          }
        }
      };
    }

    case GET_SETTINGS_TICKETING_TOOLS_SOLARWINDS_SUCCESS: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          solarWinds: {
            ...state.ticketingTools.solarWinds,
            url: action.response.url,
            apiKey: action.response.apikey,
            template: action.response.ticket_config?.template,
            client_id: action.response.client_id,
            category_id: action.response.category_id,
            location_id: action.response.location_id,
            isFetching: false
          }
        }
      };
    }

    case GET_SETTINGS_TICKETING_TOOLS_SOLARWINDS_FAIL: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          solarWinds: {
            ...state.ticketingTools.solarWinds,
            isFetching: false,
            error: true,
            message: action.message
          }
        }
      };
    }

    case SAVE_SETTINGS_TICKETING_TOOLS_SOLARWINDS_START: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          solarWinds: {
            ...state.ticketingTools.solarWinds,
            isFetching: true,
            error: false,
            message: ''
          }
        }
      };
    }

    case SAVE_SETTINGS_TICKETING_TOOLS_SOLARWINDS_SUCCESS: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          activeConfig: {
            ...state.ticketingTools.activeConfig,
            whd: {
              ...state.ticketingTools.activeConfig.whd,
              available: true
            }
          },
          solarWinds: {
            ...state.ticketingTools.solarWinds,
            isFetching: false,
            error: false
          }
        }
      };
    }

    case SAVE_SETTINGS_TICKETING_TOOLS_SOLARWINDS_FAIL: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          solarWinds: {
            ...state.ticketingTools.solarWinds,
            isFetching: false,
            error: true,
            message: action.message
          }
        }
      };
    }

    // gitlab
    case GET_SETTINGS_TICKETING_TOOLS_GITLAB_START: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          gitLab: {
            ...initialState.ticketingTools.gitLab,
            isFetching: true
          }
        }
      };
    }

    case GET_SETTINGS_TICKETING_TOOLS_GITLAB_SUCCESS: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          gitLab: {
            ...state.ticketingTools.gitLab,
            url: get(action, 'response.url', ''),
            accessToken: get(action, 'response.access_token', ''),
            project: get(action, 'response.project', ''),
            sslVerify: get(action, 'response.ssl_config.ssl_verify', false),
            selfSignedCertificate: get(action, 'response.ssl_config.self_signed_cert', false),
            template: get(action, 'response.ticket_config.template', ''),
            isFetching: false
          }
        }
      };
    }

    case GET_SETTINGS_TICKETING_TOOLS_GITLAB_FAIL: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          gitLab: {
            ...state.ticketingTools.gitLab,
            isFetching: false,
            error: true,
            message: action.message
          }
        }
      };
    }

    case SAVE_SETTINGS_TICKETING_TOOLS_GITLAB_START: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          gitLab: {
            ...state.ticketingTools.gitLab,
            isFetching: true,
            error: false,
            message: ''
          }
        }
      };
    }

    case SAVE_SETTINGS_TICKETING_TOOLS_GITLAB_SUCCESS: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          activeConfig: {
            ...state.ticketingTools.activeConfig,
            gitlab: {
              ...state.ticketingTools.activeConfig.gitlab,
              available: true
            }
          },
          gitLab: {
            ...state.ticketingTools.gitLab,
            isFetching: false,
            error: false
          }
        }
      };
    }

    case SAVE_SETTINGS_TICKETING_TOOLS_GITLAB_FAIL: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          gitLab: {
            ...state.ticketingTools.gitLab,
            isFetching: false,
            error: true,
            message: action.message
          }
        }
      };
    }

    // servicenow
    case GET_SETTINGS_TICKETING_TOOLS_SERVICE_NOW_START: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          serviceNow: {
            ...initialState.ticketingTools.serviceNow,
            isFetching: true
          }
        }
      };
    }

    case GET_SETTINGS_TICKETING_TOOLS_SERVICE_NOW_SUCCESS: {
      // const table = (action.response.ticket_config?.table && (action.response.ticket_config?.table === 'sn_vul_app_vulnerable_item')) ? 'Application Vulnerable Items' : 'Incidents';
      const table = TABLE_TO_LABEL_MAP[action.response.ticket_config?.table] ?? '';
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          serviceNow: {
            ...state.ticketingTools.serviceNow,
            authenticated: get(action, 'response.oauth.authenticated', false),
            url: get(action, 'response.url', ''),
            category: get(action, 'response.ticket_config.category', ''),
            subcategory: get(action, 'response.ticket_config.subcategory', ''),
            template: get(action, 'response.ticket_config.template', ''),
            isFetching: false,
            table
          }
        }
      };
    }

    case GET_SETTINGS_TICKETING_TOOLS_SERVICE_NOW_FAIL: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          serviceNow: {
            ...state.ticketingTools.serviceNow,
            isFetching: false,
            error: true,
            message: action.message
          }
        }
      };
    }

    case SAVE_SETTINGS_TICKETING_TOOLS_SERVICE_NOW_START: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          serviceNow: {
            ...state.ticketingTools.serviceNow,
            isFetching: true,
            error: false,
            message: ''
          }
        }
      };
    }

    case SAVE_SETTINGS_TICKETING_TOOLS_SERVICE_NOW_SUCCESS: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          activeConfig: {
            ...state.ticketingTools.activeConfig,
            servicenow: {
              ...state.ticketingTools.activeConfig.servicenow,
              available: true
            }
          },
          serviceNow: {
            ...state.ticketingTools.serviceNow,
            isFetching: false,
            error: false
          }
        }
      };
    }

    case SAVE_SETTINGS_TICKETING_TOOLS_SERVICE_NOW_FAIL: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          serviceNow: {
            ...state.ticketingTools.serviceNow,
            isFetching: false,
            error: true,
            message: action.message
          }
        }
      };
    }

    case AUTHENTICATE_SETTINGS_TICKETING_TOOLS_SERVICE_NOW_START: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          serviceNow: {
            ...state.ticketingTools.serviceNow,
            isFetching: true,
            error: false,
            message: '',
            authenticated: false
          }
        }
      };
    }

    case AUTHENTICATE_SETTINGS_TICKETING_TOOLS_SERVICE_NOW_SUCCESS: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          serviceNow: {
            ...state.ticketingTools.serviceNow,
            authenticated: true,
            isFetching: false,
            error: false,
            message: 'ServiceNow was authenticated successfully',
            username: action.response.username,
            password: action.response.password
          }
        }
      };
    }

    case AUTHENTICATE_SETTINGS_TICKETING_TOOLS_SERVICE_NOW_FAIL: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          serviceNow: {
            ...state.ticketingTools.serviceNow,
            authenticated: false,
            isFetching: false,
            error: true,
            message: action.message
          }
        }
      };
    }

    case DEAUTHENTICATE_SETTINGS_TICKETING_TOOLS_SERVICE_NOW_START: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          serviceNow: {
            ...state.ticketingTools.serviceNow,
            isFetching: true,
            error: false,
            message: ''
          }
        }
      };
    }

    case DEAUTHENTICATE_SETTINGS_TICKETING_TOOLS_SERVICE_NOW_SUCCESS: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          serviceNow: {
            ...state.ticketingTools.serviceNow,
            authenticated: false,
            isFetching: false,
            error: false,
            message: 'ServiceNow was deauthenticated successfully'
          }
        }
      };
    }

    case DEAUTHENTICATE_SETTINGS_TICKETING_TOOLS_SERVICE_NOW_FAIL: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          serviceNow: {
            ...state.ticketingTools.serviceNow,
            isFetching: false,
            error: true,
            message: action.message
          }
        }
      };
    }

    // jira
    case GET_SETTINGS_TICKETING_TOOLS_JIRA_START: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          jira: {
            ...initialState.ticketingTools.jira,
            isFetching: true
          }
        }
      };
    }

    case GET_SETTINGS_TICKETING_TOOLS_JIRA_SUCCESS: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          jira: {
            ...state.ticketingTools.jira,
            authenticated: get(action, 'response.oauth.authenticated', false),
            authorized: get(action, 'response.oauth.authenticated', false),
            url: get(action, 'response.url', ''),
            consumerKey: get(action, 'response.oauth.consumer_key', ''),
            projectKey: get(action, 'response.project_key', ''),
            issueType: get(action, 'response.ticket_config.issue_type', ''),
            template: get(action, 'response.ticket_config.template', ''),
            users: get(action, 'response.jira_users', []),
            isFetching: false,
            defaultProject: get(action, 'response.default_project', ''),
            fetchingAuthenticate: false
          }
        }
      };
    }

    case GET_SETTINGS_TICKETING_TOOLS_JIRA_FAIL: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          jira: {
            ...state.ticketingTools.jira,
            isFetching: false,
            error: true,
            message: action.message,
            fetchingAuthenticate: false
          }
        }
      };
    }

    case SAVE_SETTINGS_TICKETING_TOOLS_JIRA_START: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          jira: {
            ...state.ticketingTools.jira,
            isFetching: true,
            error: false,
            message: ''
          }
        }
      };
    }

    case SAVE_SETTINGS_TICKETING_TOOLS_JIRA_SUCCESS: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          activeConfig: {
            ...state.ticketingTools.activeConfig,
            jira: {
              ...state.ticketingTools.activeConfig.jira,
              available: true
            }
          },
          jira: {
            ...state.ticketingTools.jira,
            isFetching: false,
            error: false,
            message: action.message,
            success: true
          }
        }
      };
    }

    case SAVE_SETTINGS_TICKETING_TOOLS_JIRA_FAIL: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          jira: {
            ...state.ticketingTools.jira,
            isFetching: false,
            error: true,
            message: action.message
          }
        }
      };
    }

    case AUTHORIZE_SETTINGS_TICKETING_TOOLS_JIRA_START: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          jira: {
            ...state.ticketingTools.jira,
            isFetching: true,
            error: false,
            message: '',
            authorized: false
          }
        }
      };
    }

    case AUTHORIZE_SETTINGS_TICKETING_TOOLS_JIRA_SUCCESS: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          jira: {
            ...state.ticketingTools.jira,
            authorized: true,
            isFetching: false
          }
        }
      };
    }

    case AUTHORIZE_SETTINGS_TICKETING_TOOLS_JIRA_FAIL: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          jira: {
            ...state.ticketingTools.jira,
            authorized: false,
            isFetching: false,
            error: true,
            message: action.message
          }
        }
      };
    }

    //
    // ACCESS TOKEN
    //
    case ACCESS_SETTINGS_TICKETING_TOOLS_JIRA_START: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          jira: {
            ...state.ticketingTools.jira,
            isFetching: true,
            fetchingAuthenticate: true,
            error: false,
            message: ''
          }
        }
      };
    }

    case ACCESS_SETTINGS_TICKETING_TOOLS_JIRA_SUCCESS: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          jira: {
            ...state.ticketingTools.jira,
            authenticated: true,
            authorized: true,
            isFetching: false,
            fetchingAuthenticate: false,
            message: 'OAuth success. Settings have been saved.',
            success: true,
            error: false
          }
        }
      };
    }

    case ACCESS_SETTINGS_TICKETING_TOOLS_JIRA_FAIL: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          jira: {
            ...state.ticketingTools.jira,
            authenticated: false,
            authorized: false,
            isFetching: false,
            fetchingAuthenticate: false,
            error: true,
            success: false,
            message: action.message
          }
        }
      };
    }

    //
    // SETTINGS FIELDS
    //
    case SET_SETTINGS_TICKETING_TOOLS_JIRA_FIELD: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          jira: {
            ...state.ticketingTools.jira,
            [action.field]: action.value
          }
        }
      };
    }

    case ADD_USER_TICKETING_TOOLS_JIRA: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          jira: {
            ...state.ticketingTools.jira,
            users: [...state.ticketingTools.jira.users, { ...action.foundUser, username: action.foundUser?.label }]
          }
        }
      };
    }

    case DELETE_USER_TICKETING_TOOLS_JIRA: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          jira: {
            ...state.ticketingTools.jira,
            users: state.ticketingTools.jira.users.filter(user => user.id_ !== action.id_)
          }
        }
      };
    }

    case SET_SETTINGS_TICKETING_TOOLS_SERVICE_NOW_FIELD: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          serviceNow: {
            ...state.ticketingTools.serviceNow,
            [action.field]: action.value
          }
        }
      };
    }

    case SET_SETTINGS_TICKETING_TOOLS_GITLAB_FIELD: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          gitLab: {
            ...state.ticketingTools.gitLab,
            [action.field]: action.value
          }
        }
      };
    }

    case SET_SETTINGS_TICKETING_TOOLS_SOLARWINDS_FIELD: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          solarWinds: {
            ...state.ticketingTools.solarWinds,
            [action.field]: action.value
          }
        }
      };
    }

    case SEND_VULN_TO_TOOL: {
      return {
        ...state,
        sendVulnToTool: {
          ...state.sendVulnToTool,
          payload: action.payload
        }
      };
    }

    case GET_PROJECTS_TICKETING_TOOLS_JIRA_START: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          jira: {
            ...state.ticketingTools.jira,
            isFetching: true,
            error: false
          }
        }
      };
    }

    case GET_AVAILABLE_PROJECTS_JIRA_START: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          jira: {
            ...state.ticketingTools.jira,
            fetchingProjects: true,
            error: false
          }
        }
      };
    }

    case GET_PROJECTS_TICKETING_TOOLS_JIRA_SUCCESS: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          jira: {
            ...state.ticketingTools.jira,
            templates: action.response,
            isFetching: false,
            error: false
          }
        }
      };
    }

    case GET_PROJECTS_TICKETING_TOOLS_JIRA_FAIL: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          jira: {
            ...state.ticketingTools.jira,
            isFetching: false,
            error: true,
            message: 'Faraday was not able to fetch projects. Consumer key is not valid.'
          }
        }
      };
    }

    case ADD_TO_JIRA_PAYLOAD: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          jira: {
            ...state.ticketingTools.jira,
            payload: {
              [action.payload.key]: action.payload
            }
          }
        }
      };
    }

    case SET_JIRA_PAYLOAD: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          jira: {
            ...state.ticketingTools.jira,
            payload: action.payload
          }
        }
      };
    }
    case SET_JIRA_TEMPLATE: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          jira: {
            ...state.ticketingTools.jira,
            template: action.template
          }
        }
      };
    }

    case RESET_JIRA_PAYLOAD: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          jira: {
            ...state.ticketingTools.jira,
            payload: initialState.ticketingTools.jira.payload
          }
        }
      };
    }
    case ADD_PROJECT_JIRA_PAYLOAD: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          jira: {
            ...state.ticketingTools.jira,
            payload: {
              ...state.ticketingTools.jira.payload,
              projects_selected: [...state.ticketingTools.jira.payload.projects_selected, Object.keys(action.project)[0]],
              projects_changed: {
                ...state.ticketingTools.jira.payload.projects_changed,
                [Object.keys(action.project)[0]]: action.project
              }
            }
          }
        }
      };
    }

    case DELETE_PROJECT_JIRA_PAYLOAD: {
      // eslint-disable-next-line no-unused-vars
      const { [action.project]: del, ...projects } = state.ticketingTools.jira.payload.projects_changed;

      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          jira: {
            ...state.ticketingTools.jira,
            payload: {
              ...state.ticketingTools.jira.payload,
              projects_selected: state.ticketingTools.jira.payload.projects_selected.filter((project) => project !== action.project),
              projects_changed: projects
            }
          }
        }
      };
    }

    case SET_PROJECT_CONFIG_JIRA_PAYLOAD: {
      const projectsSelected = [...state.ticketingTools.jira.payload.projects_selected, action.key];
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          jira: {
            ...state.ticketingTools.jira,
            payload: {
              ...state.ticketingTools.jira.payload,
              projects_changed: {
                ...state.ticketingTools.jira.payload.projects_changed,
                [action.key]: {
                  ...state.ticketingTools.jira.payload.projects_changed[action.key],
                  ticket_config: action.config
                }
              },
              projects_selected: [...new Set(projectsSelected)]
            }
          }
        }
      };
    }

    case SEND_TEMPLATES_TICKETING_TOOLS_JIRA_START: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          jira: {
            ...state.ticketingTools.jira,
            isFetching: true
          }
        }
      };
    }

    case SEND_TEMPLATES_TICKETING_TOOLS_JIRA_SUCCESS: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          jira: {
            ...state.ticketingTools.jira,
            isFetching: false,
            error: false,
            message: 'Your data was saved successfully.',
            // template: {},
            ticketConfig: action.ticketConfig
          }
        }
      };
    }

    case SEND_TEMPLATES_TICKETING_TOOLS_JIRA_FAIL: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          jira: {
            ...state.ticketingTools.jira,
            isFetching: false,
            error: false,
            message: action.message
          }
        }
      };
    }

    case GET_PROJECT_TICKETING_TOOLS_JIRA_START: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          jira: {
            ...state.ticketingTools.jira,
            fetchingProjects: true,
            error: false,
            message: ''
          }
        }
      };
    }

    case GET_PROJECT_TICKETING_TOOLS_JIRA_SUCCESS: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          jira: {
            ...state.ticketingTools.jira,
            template: action.response,
            fetchingProjects: false,
            fetchingProjectData: false,
            error: false
          }
        }
      };
    }

    case SET_PROJECT_BY_DEFAULT_JIRA_START: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          jira: {
            ...state.ticketingTools.jira,
            isFetching: true,
            error: false
          }
        }
      };
    }

    case SET_PROJECT_BY_DEFAULT_JIRA_SUCCESS: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          jira: {
            ...state.ticketingTools.jira,
            isFetching: false,
            error: false,
            defaultProject: action.key
          }
        }
      };
    }

    case SET_PROJECT_BY_DEFAULT_JIRA_FAIL: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          jira: {
            ...state.ticketingTools.jira,
            isFetching: false,
            error: true,
            success: false,
            message: action.message
          }
        }
      };
    }

    case GET_PROJECT_TICKETING_TOOLS_JIRA_FAIL: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          jira: {
            ...state.ticketingTools.jira,
            fetchingProjects: false,
            fetchingProjectData: false,
            error: true,
            message: action.message
          }
        }
      };
    }

    case GET_PUBLIC_KEY_TICKETING_TOOLS_JIRA_START: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          jira: {
            ...state.ticketingTools.jira,
            isFetching: true
          }
        }
      };
    }

    case GET_PUBLIC_KEY_TICKETING_TOOLS_JIRA_SUCCESS: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          jira: {
            ...state.ticketingTools.jira,
            isFetching: false,
            error: false,
            message: 'Your data was saved successfully.',
            publicKey: action.response
          }
        }
      };
    }

    case GET_PUBLIC_KEY_TICKETING_TOOLS_JIRA_FAIL: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          jira: {
            ...state.ticketingTools.jira,
            isFetching: false,
            error: false,
            message: action.message
          }
        }
      };
    }

    case SET_IS_TEMPLATE: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          jira: {
            ...state.ticketingTools.jira,
            isTemplate: action.payload
          }
        }
      };
    }

    case GET_JIRA_AVAILABLE_PROJECTS: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          jira: {
            ...state.ticketingTools.jira,
            availableProjects: action.response,
            isFetching: false,
            fetchingProjects: false
          }
        }
      };
    }

    case GET_JIRA_CONFIGURED_PROJECTS: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          jira: {
            ...state.ticketingTools.jira,
            configuredProjects: action.response,
            isFetching: false
          }
        }
      };
    }

    case UPDATE_JIRA_CONFIGURED_PROJECT: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          jira: {
            ...state.ticketingTools.jira,
            configuredProjects: {
              ...state.ticketingTools.jira.configuredProjects,
              ...action.response
            },
            isFetching: false
          }
        }
      };
    }

    case SET_PROJECT_TO_SUBMIT_ISSUE: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          jira: {
            ...state.ticketingTools.jira,
            projectToSubmitIssue: action.projectToSubmitIssue
          }
        }
      };
    }

    case types.SETTINGS_GET_LDAP: {
      return {
        ...state,
        ldap: action.data
      };
    }

    case types.SETTINGS_SAVE_LDAP: {
      return {
        ...state,
        ldap: action.updatedLdap
      };
    }

    case types.SET_SETTINGS_LDAP_FIELD: {
      return {
        ...state,
        ldap: {
          ...state.ldap,
          [action.field]: action.value
        }
      };
    }

    case types.SETTINGS_LDAP_FAIL: {
      return {
        ...state,
        ldap: {
          ...state.ldap,
          isFetching: false
        }
      };
    }

    case types.SETTINGS_LDAP_RESET: {
      return {
        ...state,
        ldap: {
          ...initialState.ldap
        }
      };
    }

    case types.SETTINGS_SAML_FETCH: {
      return {
        ...state,
        saml: {
          ...state.saml,
          isFetching: true,
          errorMessage: ''
        }
      };
    }

    case types.SETTINGS_SAML_FAIL: {
      return {
        ...state,
        saml: {
          ...state.saml,
          isFetching: false
        }
      };
    }

    case types.SETTINGS_SAML_SUCCESS: {
      return {
        ...state,
        saml: {
          ...state.saml,
          isFetching: false,
          ...action.response
        }
      };
    }

    case types.SET_SETTINGS_SAML_FIELD: {
      return {
        ...state,
        saml: {
          ...state.saml,
          [action.field]: action.value
        }
      };
    }

    case types.SET_SETTINGS_SAML_RESET: {
      return {
        ...state,
        saml: {
          ...initialState.saml
        }
      };
    }
    case GET_ACTIVE_CONFIG_REQUEST:
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          isLoading: true,
          error: null
        }
      };
    case GET_ACTIVE_CONFIG_SUCCESS:
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          activeConfig: action.payload,
          isLoading: false,
          error: null
        }
      };
    case GET_ACTIVE_CONFIG_FAILURE:
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          isLoading: false,
          error: action.payload
        }
      };
    case UPDATE_ACTIVE_CONFIG_SUCCESS_BY_TOOL:
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          activeConfig: {
            ...state.ticketingTools.activeConfig,
            [action.tool]: {
              ...state.ticketingTools.activeConfig[action.tool],
              active: action.status
            }
          }
        }
      };

    case GET_USER_DATA_SUCCESS: {
      return {
        ...state,
        userData: action.userData
      };
    }

    case GET_USER_DATA_FAIL: {
      return {
        ...state,
        userData: {
          ...state.userData,
          error: true,
          errorMessage: action.error
        }
      };
    }

    case SET_USER_EMAIL: {
      return {
        ...state,
        userData: {
          ...state.userData,
          email: action.value
        }
      };
    }

    case SETTINGS_USER_TOKENS_FAIL: {
      return {
        ...state,
        userTokens: {
          ...state.userTokens,
          error: true,
          errorMessage: action.errorMessage
        }
      };
    }

    case SETTINGS_USER_TOKENS_RESET_ERROR: {
      return {
        ...state,
        userTokens: {
          ...state.userTokens,
          error: false,
          errorMessage: ''
        }
      };
    }

    case SETTINGS_GET_USER_TOKENS_REQUEST: {
      return {
        ...state,
        userTokens: {
          ...state.userTokens,
          isFetching: true
        }
      };
    }

    case SETTINGS_GET_USER_TOKENS_SUCCESS: {
      return {
        ...state,
        userTokens: {
          ...state.userTokens,
          isFetching: false,
          data: {
            tokens: action.data.user_tokens,
            count: action.data.count
          }
        }
      };
    }

    case SETTINGS_USER_TOKENS_SHOW_ACTION_MODAL: {
      return {
        ...state,
        userTokens: {
          ...state.userTokens,
          showActionModal: action.show,
          actionToConfirm: action.action,
          selectedTokenId: action.id
        }
      };
    }

    case SETTINGS_USER_TOKENS_SHOW_ADD_TOKEN_MODAL: {
      return {
        ...state,
        userTokens: {
          ...state.userTokens,
          showAddTokenModal: action.show,
          addTokenModalStep: action.step
        }
      };
    }

    case SETTINGS_USER_TOKENS_CREATE_SUCCESS: {
      return {
        ...state,
        userTokens: {
          ...state.userTokens,
          lastAddedToken: action.token
        }
      };
    }

    case ADD_USER_TOKEN_TO_TABLE: {
      const tokensList = state.userTokens.data.tokens;
      return {
        ...state,
        userTokens: {
          ...state.userTokens,
          data: {
            tokens: [action.token, ...tokensList],
            count: state.userTokens.data.count + 1
          },
          lastAddedToken: null
        }
      };
    }

    case RESET_LAST_ADDED_TOKEN: {
      return {
        ...state,
        userTokens: {
          ...state.userTokens,
          lastAddedToken: null
        }
      };
    }

    case SETTINGS_USER_TOKENS_SET_SELECTED_TAB: {
      return {
        ...state,
        userTokens: {
          ...state.userTokens,
          selectedTab: action.selectedTab
        }
      };
    }

    case SETTINGS_USER_TOKENS_GET_SCOPES: {
      return {
        ...state,
        userTokens: {
          ...state.userTokens,
          scopes: action.scopes
        }
      };
    }

    case SET_INSTANCE_SETTINGS_START: {
      return {
        ...state,
        isLoading: true
      };
    }

    case SET_INSTANCE_SETTINGS_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        instanceSettings: {
          allowMultipleSessions: action.response.allow_multiple_sessions
        }
      };
    }

    case SETTINGS_SERVICE_DESK_AUTH_SUCCESS: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          serviceDesk: {
            ...state.ticketingTools.serviceDesk,
            successful_login: true,
            isFetching: false,
            errorMessage: '',
            error: false
          }
        }
      };
    }

    case SETTINGS_SERVICE_DESK_AUTH_FAILURE: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          serviceDesk: {
            ...state.ticketingTools.serviceDesk,
            successful_login: false,
            isFetching: false,
            errorMessage: action.errorMessage,
            error: true
          }
        }
      };
    }

    case SETTINGS_SERVICE_DESK_DEAUTHENTICATED: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          serviceDesk: {
            ...state.ticketingTools.serviceDesk,
            successful_login: false
          }
        }
      };
    }

    case SETTINGS_SERVICE_DESK_GET_REQUESTERS_SUCCESS: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          serviceDesk: {
            ...state.ticketingTools.serviceDesk,
            isFetching: false,
            error: false,
            requesters: action.requesters
          }
        }
      };
    }

    case SETTINGS_SERVICE_DESK_GET_SEARCH_DATA_SUCCESS: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          serviceDesk: {
            ...state.ticketingTools.serviceDesk,
            isFetching: false,
            error: false,
            templateSelected: {
              ...state.ticketingTools.serviceDesk.templateSelected,
              optionsData: {
                ...state.ticketingTools.serviceDesk.templateSelected.optionsData,
                [action.field]: action.data
              }
            }
          }
        }
      };
    }

    case SETTINGS_SERVICE_DESK_GET_DROPDOWN_DATA_SUCCESS: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          serviceDesk: {
            ...state.ticketingTools.serviceDesk,
            isFetching: false,
            error: false,
            templateSelected: {
              ...state.ticketingTools.serviceDesk.templateSelected,
              optionsData: {
                ...state.ticketingTools.serviceDesk.templateSelected.optionsData,
                [action.field]: action.data
              }
            }
          }
        }
      };
    }

    case SETTINGS_SERVICE_DESK_GET_GROUPED_DROPDOWN_DATA_REQUEST: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          serviceDesk: {
            ...state.ticketingTools.serviceDesk,
            isFetching: false,
            error: false,
            templateSelected: {
              ...state.ticketingTools.serviceDesk.templateSelected,
              isFetchingGroupedData: true,
              optionsData: {
                ...state.ticketingTools.serviceDesk.templateSelected.optionsData
              }
            }
          }
        }
      };
    }

    case SETTINGS_SERVICE_DESK_GET_GROUPED_DROPDOWN_DATA_SUCCESS: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          serviceDesk: {
            ...state.ticketingTools.serviceDesk,
            isFetching: false,
            error: false,
            templateSelected: {
              ...state.ticketingTools.serviceDesk.templateSelected,
              isFetchingGroupedData: false,
              optionsData: {
                ...state.ticketingTools.serviceDesk.templateSelected.optionsData,
                [action.field]: action.data
              }
            }
          }
        }
      };
    }

    case SETTINGS_SERVICE_DESK_TEMPLATES_REQUEST: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          serviceDesk: {
            ...state.ticketingTools.serviceDesk,
            isFetchingTemplates: true,
            errorMessage: '',
            error: false
          }
        }
      };
    }

    case SETTINGS_SERVICE_DESK_TEMPLATES_FAILURE: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          serviceDesk: {
            ...state.ticketingTools.serviceDesk,
            isFetchingTemplates: false,
            errorMessage: action.errorMessage,
            error: true
          }
        }
      };
    }

    case SETTINGS_SERVICE_DESK_TEMPLATES_SUCCESS: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          serviceDesk: {
            ...state.ticketingTools.serviceDesk,
            isFetchingTemplates: false,
            errorMessage: '',
            error: false,
            templates: action.templates
          }
        }
      };
    }

    case SETTINGS_SERVICE_DESK_REQUEST: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          serviceDesk: {
            ...state.ticketingTools.serviceDesk,
            isFetching: true,
            errorMessage: '',
            error: false
          }
        }
      };
    }

    case SETTINGS_SERVICE_DESK_FAILURE: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          serviceDesk: {
            ...state.ticketingTools.serviceDesk,
            isFetching: false,
            errorMessage: action.errorMessage,
            error: true,
            isFetchingTemplateData: false,
            templateSelected: {
              ...state.ticketingTools.serviceDesk.templateSelected,
              isFetchingGroupedData: false
            }
          }
        }
      };
    }

    case SETTINGS_SERVICE_DESK_SUCCESS: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          serviceDesk: {
            ...state.ticketingTools.serviceDesk,
            isFetching: false,
            ...action.response
          }
        }
      };
    }

    case SETTINGS_SERVICE_DESK_SET_FIELD: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          serviceDesk: {
            ...state.ticketingTools.serviceDesk,
            [action.field]: action.value
          }
        }
      };
    }

    case SETTINGS_SERVICE_DESK_RESET: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          serviceDesk: {
            ...initialState.ticketingTools.serviceDesk
          }
        }
      };
    }

    case SETTINGS_SERVICE_DESK_SET_REQUESTER: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          serviceDesk: {
            ...state.ticketingTools.serviceDesk,
            requester: action.item
          }
        }
      };
    }

    case SETTINGS_SERVICE_DESK_SET_VALUE_SEARCH: {
      const prevValues = state.ticketingTools.serviceDesk[action.fieldname] || [];
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          serviceDesk: {
            ...state.ticketingTools.serviceDesk,
            [action.fieldname]: [...prevValues, action.item]
          }
        }
      };
    }

    case SETTINGS_SERVICE_DESK_REMOVE_VALUE_SEARCH: {
      const values = state.ticketingTools.serviceDesk[action.fieldname].filter((u) => u !== action.item);
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          serviceDesk: {
            ...state.ticketingTools.serviceDesk,
            [action.fieldname]: values
          }
        }
      };
    }

    case SETTINGS_SERVICE_DESK_TEMPLATE_DATA_REQUEST: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          serviceDesk: {
            ...state.ticketingTools.serviceDesk,
            isFetchingTemplateData: true,
            errorMessage: '',
            error: false
          }
        }
      };
    }

    case SETTINGS_SERVICE_DESK_TEMPLATE_DATA_SUCCESS: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          serviceDesk: {
            ...state.ticketingTools.serviceDesk,
            isFetching: false,
            errorMessage: '',
            error: false,
            templateToEdit: action.templateToEdit
          }
        }
      };
    }

    case SETTINGS_SERVICE_DESK_SET_SEVERITIES_TYPE: {
      const configSeverities = state.ticketingTools.serviceDesk.severity_outgoing;
      const newConfigSeverities = Object.assign(configSeverities, action.severity);
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          serviceDesk: {
            ...state.ticketingTools.serviceDesk,
            severity_outgoing: newConfigSeverities
          }
        }
      };
    }

    case SETTINGS_SERVICE_DESK_SET_OUTGOING_STATUS: {
      const configStatuses = state.ticketingTools.serviceDesk.status_outgoing;
      const newOutgoingStatuses = Object.assign(configStatuses, action.status);
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          serviceDesk: {
            ...state.ticketingTools.serviceDesk,
            status_outgoing: newOutgoingStatuses
          }
        }
      };
    }

    case SETTINGS_SERVICE_DESK_SET_INCOMING_STATUS: {
      const configStatuses = state.ticketingTools.serviceDesk.status_incoming;
      const newIncomingStatuses = Object.assign(configStatuses, action.status);
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          serviceDesk: {
            ...state.ticketingTools.serviceDesk,
            status_incoming: newIncomingStatuses
          }
        }
      };
    }

    case SETTINGS_SERVICE_DESK_BASIC_SETUP_SUCCESS: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          serviceDesk: {
            ...state.ticketingTools.serviceDesk,
            basicSetupFilled: true,
            basic_setup_configured: true
          }
        }
      };
    }

    case SETTINGS_SERVICE_DESK_BASIC_SETUP_FAILURE: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          serviceDesk: {
            ...state.ticketingTools.serviceDesk,
            basicSetupFilled: false,
            error: true,
            errorMessage: action.errorMessage,
            basic_setup_configured: false
          }
        }
      };
    }

    case SETTINGS_SERVICE_DESK_SAVE_TEMPLATES_SUCCESS: {
      const templatesAdded = get(action, 'response.template_list', {});
      const parsedTemplates = Object.keys(templatesAdded).length > 0
        ? Object.keys(templatesAdded).map(key => {
          const arr = key.split(' - ');
          return { name: arr[0], id: arr[1], fields: templatesAdded[key] };
        })
        : [];

      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          serviceDesk: {
            ...state.ticketingTools.serviceDesk,
            template_list: parsedTemplates,
            templateSelected: {},
            active_template: get(action, 'response.active_template', '')
          }
        }
      };
    }

    case SETTINGS_SERVICE_DESK_SAVE_TEMPLATES_FAILURE: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          serviceDesk: {
            ...state.ticketingTools.serviceDesk,
            error: true,
            errorMessage: action.errorMessage
          }
        }
      };
    }

    case GET_SETTINGS_TICKETING_TOOLS_SERVICE_DESK_START: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          serviceDesk: {
            ...initialState.ticketingTools.serviceDesk,
            isFetching: true
          }
        }
      };
    }

    case GET_SETTINGS_TICKETING_TOOLS_SERVICE_DESK_SUCCESS: {
      const templatesAdded = get(action, 'response.template_list', {});
      const parsedTemplates = Object.keys(templatesAdded).length > 0
        ? Object.keys(templatesAdded).map(key => {
          const arr = key.split(' - ');
          return { name: arr[0], id: arr[1], fields: templatesAdded[key] };
        })
        : [];

      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          serviceDesk: {
            ...state.ticketingTools.serviceDesk,
            url: get(action, 'response.url', ''),
            api_token: get(action, 'response.api_token', ''),
            requester: get(action, 'response.requester', ''),
            severity_outgoing: get(action, 'response.severity_outgoing', {}),
            status_incoming: get(action, 'response.status_incoming', {}),
            status_outgoing: get(action, 'response.status_outgoing', {}),
            active_template: get(action, 'response.active_template', ''),
            template_list: parsedTemplates,
            successful_login: get(action, 'response.successful_login', false),
            basic_setup_configured: get(action, 'response.basic_setup_configured', false)
          }
        }
      };
    }

    case GET_SETTINGS_TICKETING_TOOLS_SERVICE_DESK_FAIL: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          serviceDesk: {
            ...state.ticketingTools.serviceDesk,
            isFetching: false,
            error: true,
            errorMessage: action.message
          }
        }
      };
    }

    case SETTINGS_SERVICE_DESK_ACTIVATE_TEMPLATE_SUCCESS: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          serviceDesk: {
            ...state.ticketingTools.serviceDesk,
            active_template: get(action, 'response.active_template', '')
          }
        }
      };
    }

    case SETTINGS_SERVICE_DESK_ACTIVATE_TEMPLATE_FAILURE: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          serviceDesk: {
            ...state.ticketingTools.serviceDesk,
            error: true,
            errorMessage: action.errorMessage
          }
        }
      };
    }

    case SETTINGS_SERVICE_DESK_DELETE_TEMPLATE_SUCCESS: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          serviceDesk: {
            ...state.ticketingTools.serviceDesk,
            template_list: action.template_list
          }
        }
      };
    }

    case SETTINGS_SERVICE_DESK_DELETE_TEMPLATE_FAILURE: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          serviceDesk: {
            ...state.ticketingTools.serviceDesk,
            error: true,
            errorMessage: action.errorMessage
          }
        }
      };
    }

    case UPDATE_ACTIVE_CONFIG_FAILURE: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          [action.tool]: {
            ...state.ticketingTools[action.tool],
            error: true,
            errorMessage: action.error
          }
        }
      };
    }

    case TEMPLATE_SELECTED_SD: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          serviceDesk: {
            ...state.ticketingTools.serviceDesk,
            templateSelected: action.templateSelected,
            isFetchingTemplateData: false
          }
        }
      };
    }

    case SETTINGS_SERVICE_DESK_UPDATE_TEMPLATE_SELECTED: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          serviceDesk: {
            ...state.ticketingTools.serviceDesk,
            templateSelected: action.templateSelected,
            template_list: action.templatesAdded
          }
        }
      };
    }

    case SETTINGS_SERVICE_DESK_RESET_TEMPLATE: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          serviceDesk: {
            ...state.ticketingTools.serviceDesk,
            templateSelected: {},
            templateToEdit: {}
          }
        }
      };
    }

    case FETCHING_AUTHENTICATE_START: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          jira: {
            ...state.ticketingTools.jira,
            fetchingAuthenticate: true
          }
        }
      };
    }

    case SET_STATUS:
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          [action.tool]: {
            ...state.ticketingTools[action.tool],
            [action.statusType]: action.status,
            message: action.message
          }
        }
      };

    case GET_PROJECT_DATA_START: {
      return {
        ...state,
        ticketingTools: {
          ...state.ticketingTools,
          jira: {
            ...state.ticketingTools.jira,
            fetchingProjectData: true,
            error: false,
            message: ''
          }
        }
      };
    }

    case SET_VERIFY_EMAIL_DATA: {
      return {
        ...state,
        verifyEmail: {
          ...state.verifyEmailData,
          message: action.message
        }
      };
    }

    case SET_EMAIL_TO_VERIFY: {
      return {
        ...state,
        verifyEmail: {
          ...state.verifyEmailData,
          emailToVerify: action.value
        }
      };
    }

    default: {
      return state;
    }
  }
}

export default settings;
